import { ReactElement } from "react";
import { IHostSystemInformation } from "./types";
import GaugeChartV2 from "../../../components/charts/gaugeChartV2";
import { IGaugeConfig } from "../../../components/charts/types";
import { formatBytes, getBgColor } from "./utils";

interface IProps {
  status: IHostSystemInformation;
}

const SystemComponent = ({ status }: IProps): ReactElement => {

  return (
    <div className="display-flex-column flex-grow-0 mb-2">
      <strong>File System</strong>
      <div className="display-flex-row gap-2 mr-1 ml-1" >
        {status.fsSize.map((fs, index) => {
          const fsGaugeConfig: IGaugeConfig = {
            width: 150,
            height: 150,
            minimum: 0,
            maximum: fs.size,
            start: 270,
            length: 180,
            color: undefined,
            segments: [
              { start: 0, end: fs.size * .75, color: "green" },
              { start: fs.size * .75, end: fs.size * .9, color: "orange" },
              { start: fs.size * .9, end: fs.size, color: "red" }
            ],
            format: n => formatBytes(n, 1)
          };

          const background = getBgColor(fs.used, fs.size * .75, fs.size * .9);

          return (
            <div key={`disk-${status.code}-${index}`} className="indicator" style={{ width: 250, height: 100, background }}>
              <div className="display-flex-row">
                <div className="justify-self-start flex-grow-1">{fs.mount}</div>
                <div >{fs.use}%</div>
              </div>

              <GaugeChartV2 gaugeConfig={fsGaugeConfig} value={fs.used}/>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SystemComponent;